import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class MainSlider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        return (

            <section className="ps-section--banner">
                        <div className="ps-section__overlay">
                            <div className="ps-section__loading">
                                <img src="/assets/img/main-slider-loader.svg" alt="Loading banner" className="ps-section__loadingIcon" />
                            </div>
                        </div>
                        <div className="owl-carouse-slider owl-carousel" data-owl-auto="true" data-owl-loop="true" data-owl-speed="10000" data-owl-gap="0" data-owl-nav="true" data-owl-dots="false" data-owl-item="1" data-owl-item-xs="1" data-owl-item-sm="1" data-owl-item-md="1" data-owl-item-lg="1" data-owl-duration="1000" data-owl-mousedrag="on">
                            
                        {
                        this.props.mainslider.map((mainbannerItems)=>{
                        return(
                            <div className="ps-banner ps-bannerbg">
                                <div className="container-fluid container-initial customBannerContainer">
                                        <img className="ps-banner__image" src={mainbannerItems.image_path} />
                                </div>
                            </div>

                             )
                            })
                        }

                        </div>
                    </section>
        );
    }
}

export default MainSlider;
